import { Injectable } from '@angular/core';
import { IAdapter } from 'src/app/models';
import { FamilyTree } from 'src/app/models/domain';
import { YPMFAMILYTREESRVFamilyTree } from 'src/generated-clients/familytree';

@Injectable({
  providedIn: 'root',
})
export class FamilyTreeAdapter implements IAdapter<FamilyTree, YPMFAMILYTREESRVFamilyTree> {
  public adaptToDomain(item: YPMFAMILYTREESRVFamilyTree): FamilyTree {
    return new FamilyTree(
      item.designID ?? '',
      item.physicalMaterial ?? '',
      item.description ?? '',
      item.color ?? '',
      item.colourDescription ?? '',
      item.infoCode ?? '',
      undefined
    );
  }
}
